var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.15 11.393l.892-.891.435.435-.891.891zm.87.87l.892-.891.435.435-.891.891zm.87.87l.892-.891.435.435-.891.891zm.87.87l.892-.891.435.435-.891.892zM22.629 15l-9.971-9.97-6.364 6.363L9.899 15H9v8h15v-8zm-12.013 7H10v-1.26h.615zm1.231 0h-.615v-1.26h.615zm.037-3.299H10v-.365l.364-.31c.564-.534.846-.816.873-1.126 0-.224-.14-.394-.451-.394a.916.916 0 00-.561.226l-.17-.45a1.528 1.528 0 01.873-.282.837.837 0 01.923.74.848.848 0 01.005.104 1.565 1.565 0 01-.73 1.154l-.225.197h.983zM13.078 22h-.615v-1.26h.615zm.446-8.017l-.891.891.125.126h-1.444l-3.606-3.607 4.95-4.95L21.214 15h-7.837l.582-.582zM14.308 22h-.616v-1.26h.616zm1.23 0h-.615v-1.26h.616zm1.231 0h-.615v-1.26h.615zM18 22h-.615v-1.26H18zm1.308 0h-.616v-1.26h.616zm1.23 0h-.615v-1.26h.615zm1.231 0h-.615v-1.26h.615zM23 22h-.615v-1.26H23zM12.483 8.061l.731.255.366.365-1.885 1.886-.422-.423 1.492-1.492-.534-.197z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--tickets-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TicketsCircleIcon';
export default Icon;